var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-filtered-select',{attrs:{"selected-key":_vm.selectedCustomer ? _vm.selectedCustomer.value : null,"options":_vm.customerOptions,"invalid":_vm.invalid,"placeholder":"Customer"},on:{"updateDropdownValue":_vm.onUpdateValue,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }